import { useDispatch, useSelector } from "react-redux";
import { SetZipFile, SetZipMessage, SetXlsxFile, SetXlsxMessage, ResetZipFile, ResetXlsxFile } from "../../actions/filesActions";
import { HideToastMessage } from "../../actions/toastActions";
import { FileDropzone } from "../../components/Dropzone/FileDropzone";
import { AppState } from "../../store/configureStore";
import { ValidationProcess } from "../../store/validationProcess";

export const StudyFileDropzones = () => {
    const dispatch = useDispatch();
    const { zipMessage, xlsxMessage, zipFile, xlsxFile } = useSelector((state: AppState) => state.files);
    const validationProcess = useSelector((state: AppState) => state.validationProcess.process);
    const disabledF420upload = !(validationProcess === ValidationProcess.IntraDay || validationProcess === ValidationProcess.DayAhead);

    const handleSetZipFile = (file: File) => {
        if (xlsxFile) {
            dispatch(ResetXlsxFile());
        }
        dispatch(SetZipFile(file));
        dispatch(HideToastMessage());
        dispatch(SetZipMessage(file.name));
    };

    const handleSetXlsxFile = (file: File) => {
        if (zipFile) {
            dispatch(ResetZipFile());
        }
        dispatch(SetXlsxFile(file));
        dispatch(HideToastMessage());
        dispatch(SetXlsxMessage(file.name));
    };

    return (
        <>
            <div id="file-dropzone-studyFile-a" className="file-dropzone">
                <div id="dropzone-message-studyFile-a" className="dropzone-message-status">
                    <p id="f427-conversion-studyFile" className="f427-conversion">Upload file for F427 conversion</p>
                </div>
                <FileDropzone essential="fileDropzone-studyFileDropzones-a" handleSetFile={handleSetXlsxFile} msg={disabledF420upload ? "Not available for selected process" : xlsxMessage} disabled={disabledF420upload} />
            </div>
            <div id="file-dropzone-studyFile-b" className="file-dropzone">
                <div id="dropzone-message-studyFile-b" className="dropzone-message-status">
                    <p id="estimate-security-reserve-studyFile" className="estimate-security-reserve">
                        Upload zip with TSO data for validation
                    </p>
                </div>
                <FileDropzone essential="fileDropzone-studyFileDropzones-b" handleSetFile={handleSetZipFile} msg={zipMessage} />
            </div>
        </>
    );
};
